import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { relewiseMappingService } from '../MappingService';
import { relewiseTrackingService } from '../TrackingService';

export const useProductEngagementTracker = (product: SimpleProduct | undefined) => {
    const trackProductEngagement = (isFavorite: boolean) => {
        if (!product || !product.ItemId) {
            return;
        }

        const variantId = relewiseMappingService.mapSimpleProductToRelewiseVariantId(product);
        relewiseTrackingService.trackProductEngagement(relewiseMappingService.prefixId(product.ItemId), isFavorite, variantId);
    };

    return { trackProductEngagement };
};
